import { defaultTranscricaoState } from './defaultState';
import { TranscricaoAction, TranscricaoState } from './types';

export const transcricaoReducer = (
    state: TranscricaoState,
    action: TranscricaoAction
): TranscricaoState => {
    switch (action.type) {
        case 'SET_STEP':
            return { ...state, currentStep: action.payload };
        case 'SET_ANEXOS':
            return { ...state, anexos: action.payload };
        case 'SET_VALIDANDO_ANEXO':
            if (state.validandoAnexo === action.payload) return state;
            return { ...state, validandoAnexo: action.payload };
        case 'SET_TERMOS_ACEITOS':
            return { ...state, termosAceitos: action.payload };
        case 'SET_DATA_ACEITE':
            return { ...state, dataAceite: action.payload };
        case 'SET_ID_TRANSCRICAO':
            return { ...state, idTranscricao: action.payload };
        case 'SET_ORIGEM_REVISAO':
            return { ...state, origemRevisao: action.payload };
        case 'SET_REVISAO_STATUS':
            return { ...state, revisaoStatus: action.payload };
        case 'SET_PROCEDIMENTOS':
            return { ...state, procedimentos: action.payload };
        case 'UPDATE_PROCEDIMENTO':
            return {
                ...state,
                procedimentos: state.procedimentos.map((item) =>
                    item.idTranscricaoItem === action.payload.idTranscricaoItem
                        ? action.payload
                        : item,
                ),
            };
        case 'SET_DETALHE_TRANSCRICAO':
            return { ...state, detalheTranscricao: action.payload };
        case 'RESET':
            return defaultTranscricaoState;
        default:
            return state;
    }
};
